<template>
  <div class="pt-32 pb-16">
    <ContentWrapper>
      <p
        v-if="section"
        class="text-sm font-semibold text-primary-600 uppercase tracking-wide mb-2"
      >
        {{ section }}
      </p>
      <h1 class="text-3xl md:text-4xl font-headings font-bold text-primary-900">
        {{ title }}
      </h1>
      <div class="mt-6 max-w-5xl space-y-4 text-gray-600 leading-relaxed text-lg">
        <slot />
      </div>
    </ContentWrapper>
  </div>
</template>

<script setup>
import ContentWrapper from '@/components/Layouts/ContentWrapper.vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  section: {
    type: String,
    default: ''
  }
})
</script>
